import TipoVeiculo from "./TipoVeiculo";
import MarcaModeloVeiculo from "./MarcaModeloVeiculo";
import EspecieVeiculo from "./EspecieVeiculo";
import Municipio from "./Municipio";

class VeiculoAutoInfracaoTransito {
    constructor(
        {
            id = null,
            auto_infracao_transito_id = null,
            placa_veiculo = null,
            codigo_renavam = null,
            uf_emplacamento = null,
            municipio_emplacamento_id = null,
            tipo_veiculo_id = null,
            cor_veiculo_id = null,
            especie_veiculo_id = null,
            categoria_veiculo_id = null,
            marca_modelo_veiculo_id = null,
            placa_antiga = null,
            data_recibo = null,
            data_impedimento_nao_transferencia = null,
            codigo_carroceria = null,
            codigo_restricao_1 = null,
            codigo_restricao_2 = null,
            codigo_restricao_3 = null,
            codigo_restricao_4 = null,
            indicador_restricao_renajud = null,
            indicador_restricao_renavam = null,
            indicador_roubo_furto_renavam = null,
            indicador_exigibilidade = null,
            sne_indicador_adesao_veiculo = null,
            sne_indicador_adesao_orgao_autuador = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            tipo_veiculo = {},
            marca_modelo_veiculo = {},
            especie_veiculo = {},
            municipio_emplacamento = {}
        } = {}
    ) {
        this.id = id;
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.placa_veiculo = placa_veiculo;
        this.codigo_renavam = codigo_renavam;
        this.uf_emplacamento = uf_emplacamento;
        this.municipio_emplacamento_id = municipio_emplacamento_id;
        this.tipo_veiculo_id = tipo_veiculo_id;
        this.cor_veiculo_id = cor_veiculo_id;
        this.especie_veiculo_id = especie_veiculo_id;
        this.categoria_veiculo_id = categoria_veiculo_id;
        this.marca_modelo_veiculo_id = marca_modelo_veiculo_id;
        this.placa_antiga = placa_antiga;
        this.data_recibo = data_recibo;
        this.data_impedimento_nao_transferencia = data_impedimento_nao_transferencia;
        this.codigo_carroceria = codigo_carroceria;
        this.codigo_restricao_1 = codigo_restricao_1;
        this.codigo_restricao_2 = codigo_restricao_2;
        this.codigo_restricao_3 = codigo_restricao_3;
        this.codigo_restricao_4 = codigo_restricao_4;
        this.indicador_restricao_renajud = indicador_restricao_renajud;
        this.indicador_restricao_renavam = indicador_restricao_renavam;
        this.indicador_roubo_furto_renavam = indicador_roubo_furto_renavam;
        this.indicador_exigibilidade = indicador_exigibilidade;
        this.sne_indicador_adesao_veiculo = sne_indicador_adesao_veiculo;
        this.sne_indicador_adesao_orgao_autuador = sne_indicador_adesao_orgao_autuador;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.tipo_veiculo = tipo_veiculo ? new TipoVeiculo(tipo_veiculo) : new TipoVeiculo();
        this.marca_modelo_veiculo = marca_modelo_veiculo ? new MarcaModeloVeiculo(marca_modelo_veiculo) : new MarcaModeloVeiculo();
        this.especie_veiculo = especie_veiculo ? new EspecieVeiculo(especie_veiculo) : new EspecieVeiculo();
        this.municipio_emplacamento = municipio_emplacamento ? new Municipio(municipio_emplacamento) : new Municipio();

        
    }
}

export default VeiculoAutoInfracaoTransito;